import React, { Component } from 'react';
import { translate } from 'react-i18next';
import cn from 'classnames';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { ResearchStoreProp } from '../../stores/props';
import UserAgentLabel from '../UserAgentMenu/UserAgentLabel';
import UserAgentMenu from '../UserAgentMenu/UserAgentMenu';
import FuseButton from '../FuseControls/FuseButton';
import BrowserStore from '../../browser/stores/BrowserStore';
import { isFuse5Enabled } from '../../fuseFeatureFlag';
import OldTopBarResearchUA from './OldTopBarResearchUA';
import './TopBarResearchUA.css';

class NewTopBarResearchUA extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        browser: BrowserStore.PropType.isRequired,
        research: ResearchStoreProp,
        onRefresh: PropTypes.func,
        className: PropTypes.string,
        btnProps: PropTypes.shape(FuseButton.propTypes),
    };
    commonProps() {
        const { research, t } = this.props;
        return {
            onClick: research.userAgentMenu.toggle,
            title: t('browserTopBar.menuButtonTitle'),
        };
    }
    getModal() {
        return this.props.research.userAgentMenu.isOpen
            ? <UserAgentMenu afterChange={this.props.onRefresh} />
            : null;
    }
    renderAlternative() {
        const { browser, btnProps, className, research } = this.props;
        const isTopBarMinified = browser.isTopBarMinificationAllowed();

        const btnIsOpen = research.userAgentMenu.isOpen;
        const mergedBtnProps = {
            ...btnProps,
            className: cn('NewTopBarResearchUA__btn', btnProps && btnProps.className, {
                'NewTopBarResearchUA__btn--focused': btnIsOpen,
            }),
            wrapperClassName: cn('NewTopBarResearchUA__btnWrapper', btnProps && btnProps.wrapperClassName),
            iconRightClassName: cn('NewTopBarResearchUA__btnIconRight', btnProps && btnProps.iconRightClassName),
        };

        return <div className={cn('NewTopBarResearchUA', className)} >
            <FuseButton
                type="quaternary"
                color="black"
                iconRight="keyboard_arrow_down"
                focus={research.userAgentMenu.isOpen}
                {...this.commonProps()}
                extraSmall={isTopBarMinified}
                {...mergedBtnProps}
            >
                {this.getLabel()}
            </FuseButton>
            {this.getModal()}
        </div>;
    }
    getLabel() {
        return <UserAgentLabel />;
    }
    render() {
        return this.renderAlternative();
    }
}

const WrappedNewTopBarResearchUA = translate()(inject('env', 'research', 'browser')(observer(NewTopBarResearchUA)));

const TopBarResearchUA = (props) => {
    return isFuse5Enabled() ? <WrappedNewTopBarResearchUA {...props} /> : <OldTopBarResearchUA {...props} />;
};

export default TopBarResearchUA;
